import React, { FunctionComponent } from 'react'
import { AddProductFast, VariantPicker } from '@vend/business-components'
import { createPortal } from 'react-dom'
import { reactular } from '@vendhq/reactular'
import { GiftCardModal } from '../gift-cards/modal/GiftCardModal'
import { useAddProductToSale } from './useAddProductToSale'

export const AddProductToSaleModals: FunctionComponent = () => {
  const {
    addProductOptions,
    variantPickerOptions,
    showGiftCardModal,
    closeGiftCardModal,
  } = useAddProductToSale()
  return (
    <>
      {variantPickerOptions &&
        !addProductOptions &&
        createPortal(
          // Seems to be a problem with the type of the variantpicker
          // @ts-expect-error
          <VariantPicker {...variantPickerOptions} />,
          document.body
        )}
      {addProductOptions &&
        createPortal(<AddProductFast {...addProductOptions} />, document.body)}
      {showGiftCardModal && (
        <GiftCardModal
          flow={'SELLING'}
          giftCardType={'BALANCES'}
          onClose={closeGiftCardModal}
        />
      )}
    </>
  )
}

export const AddProductToSaleModalsComponent = reactular(
  AddProductToSaleModals,
  [],
  'reactWrapper'
)
